import React, { useState, useEffect } from 'react';
import { User } from '../../types';
import LoadingSpinner from '../ui/LoadingSpinner';
import StudentProgressTab from './StudentProgressTab';
import { api } from '../../utils/api';

interface ParentDashboardProps {
  user: User;
}

const ParentDashboard: React.FC<ParentDashboardProps> = ({ user }) => {
  const [children, setChildren] = useState<User[]>([]);
  const [selectedChild, setSelectedChild] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchChildren = async () => {
      if (!user) return;
      setLoading(true);
      setError(null);
      try {
        const data = await api.get<User[]>(`/api/v1/parent/${user.user_id}/students`);
        setChildren(data);
        if (data.length > 0) {
          setSelectedChild(data[0]);
        }
      } catch(e) {
        if (e instanceof Error) setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchChildren();
  }, [user]);


  if (loading) return <LoadingSpinner message="Loading dashboard..." />;
  if (error) return <p className="text-red-500 text-center">{error}</p>;

  return (
    <div className="w-full max-w-4xl">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">Parent Dashboard</h2>

      {/* Children Progress Section */}
      {children.length > 0 && selectedChild ? (
        <>
          <div className="mb-6 max-w-md">
            <label htmlFor="child-select" className="block text-sm font-medium text-gray-700">Viewing Progress For:</label>
            <select
              id="child-select"
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              value={selectedChild.user_id}
              onChange={(e) => {
                const newSelectedChild = children.find(c => c.user_id === e.target.value);
                setSelectedChild(newSelectedChild || null);
              }}
            >
              {children.map(c => (
                <option key={c.user_id} value={c.user_id}>{c.first_name} {c.last_name}</option>
              ))}
            </select>
          </div>
          <StudentProgressTab student={selectedChild} />
        </>
      ) : (
         <p className="text-center text-gray-600">
           You are not currently linked to any students. A teacher can link you to a student from their dashboard.
         </p>
      )}
    </div>
  );
};

export default ParentDashboard;